module.exports = __webpack_public_path__ + "static/media/USAFacts.40c01901.png";